import { createFileRoute, Outlet } from "@tanstack/solid-router";
import { backendService } from "../../../../backend/backend.service";
import { ValidationError } from "../../../../backend/models/errors/Validation.error";

export const Route = createFileRoute("/history/$formId/$categoryId/$sectionId")(
  {
    loader: async ({ params, parentMatchPromise }) => {
      const sectionId = Number(params.sectionId);

      if (!Number.isInteger(sectionId)) {
        throw new ValidationError(
          "Parameter is not valid",
          "SECTION",
          "sectionId",
          params.sectionId
        );
      }

      const parentMatch = await parentMatchPromise;
      const parentLoaderData = parentMatch.loaderData;

      if (!parentLoaderData) {
        throw new Error("Failed to load parentData");
      }

      const section = await backendService.getSection(sectionId);

      const items = await backendService.getItems(
        sectionId,
        parentLoaderData.formId
      );
      // const sId = Number(sectionId);
      // const fId = Number(formId);

      // const section = await database.sections.get(sId);

      // const items = await databaseService.getItems(sId, fId);

      return {
        section,
        items,
        formId: parentLoaderData.formId,
        formName: parentLoaderData.formName,
        categoryId: parentLoaderData.category.id,
        categoryName: parentLoaderData.category.title,
      };
    },
    component: RouteComponent,
  }
);

function RouteComponent() {
  return <Outlet />;
}
